import pic1 from './fintrack.jpg';
import pic2 from './edulearn.jpg';
import pic3 from './medcare.jpg';
import pic4 from './studentdetail.jpg';
import pic5 from './nekooldage.jpg';
import pic6 from './c19.jpg';

const webdev = [
    {
        id: 1,
        image: pic1,
        title: "FinTrack",
        Desc: "Created an all-inclusive finance management website with a range of features including expense and budget management, EMI calculations, portfolio overviews and stock recommendations.",
        stack: "ReactJS, NodeJS",
        Github: "https://github.com/sanikaardekar/FinTrack",
        Link: "https://fin-track.vercel.app/",
        Mentions: "Top 10 Finalists at HackNiche 2023 organised by Google Developer Student Clubs"
    },
    {
        id: 2,
        image: pic2,
        title: "Edulearn",
        Desc: "A platform for interactive math learning, mythological crosswords for cultural enrichment, and interview simulations for honing communication skills. The integrated calendar and video chat features further enhance user experience, offering a seamless and comprehensive educational journey.",
        stack: "ReactJS",
        Github: "",
        Link: "https://devfolio.co/projects/edulearn-06ab",
        Mentions: "1st Place Winner at NIT Durgapur Hackoverflow 6.0 2023"
    },
    {
        id: 3,
        image: pic3,
        title: "MedCare",
        Desc: "Our inclusive mental health platform, catering to individuals aged 15 and above, offers diverse features such as multilingual yoga, timed meditation with a calming playlist, group video calls for community interaction, anonymous posting for expression, and a feedback system for continual improvement, promoting well-being for all.",
        stack: "ReactJS, DJango Rest",
        Github: "https://github.com/sanikaardekar/Make4thon_MedCare",
        Link: "https://www.loom.com/share/cb24d1c0703046a3a20a57302cee8a99",
        Mentions: "Microsoft League Hacking Make4thon 2022   - Lead my team to win 1st place in the title track 'Mental Health'"
    },

    {
        id: 4,
        image: pic4,
        title: "Student Detail App - Library Management System",
        Desc: "An admin Only Library Management System application that can be run as a container on the cloud for creating/updating/deleting a student",
        stack: "ReactJS, Flask, Docker",
        Github: "https://github.com/sanikaardekar/AFourathon-Nekoma",
        Link: "https://nekoma-library-student-detail.netlify.app/",
        Mentions: "Built at AFourathon 2023"
    },
    {
        id: 5,
        image: pic5,
        title: "Neko Old Age",
        Desc: "Neko Old Age Home serves as a connecting factor between old aged people and their family members. The relative(s) can keep track of health conditions of their family member, also if the relative(s) wants to communicate with their family member they have an option of video call and chat.",
        stack: "ReactJS, Django Rest",
        Github: "https://github.com/sanikaardekar/Neko-Old-Age-1",
        Link: "",
        Mentions: "Built at Code Odyssey 2022"
    },
    {
        id: 6,
        image: pic6,
        title: "C19",
        Desc: "Developed a website to showcase real-time Covid-19 data through interactive tables, charts, and a powerful search functionality.",
        stack: "Javascript",
        Github: "https://github.com/sanikaardekar/C19-Data-Display-unicode-task2-",
        Link: "",
        Mentions: "Practise Project"
    }


]
export default webdev;